import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as Feather from 'feather-icons';
import { HeaderService } from 'app/services/header/header.service';
import {
  AccesLogicielCaisseRow,
  AccesLogicielCaisseService,
  AccesSyncStatus,
} from 'app/services/logiciel-caisse/acces-logiciel-caisse.service';
import { LogicielCaisseAuthService } from 'app/services/logiciel-caisse/logiciel-caisse-auth.service';
import { LogicielCaisseModuleService } from 'app/services/logiciel-caisse/logiciel-caisse-module.service';
import { navigateLogicielCaisseReturnUrl } from 'app/services/logiciel-caisse/logiciel-caisse-return-url.util';

@Component({
  selector: 'app-acces-logiciel-caisse-list',
  templateUrl: './acces-logiciel-caisse-list.component.html',
  styleUrls: ['./acces-logiciel-caisse-list.component.scss'],
})
export class AccesLogicielCaisseListComponent implements OnInit, AfterViewInit {
  loading = true;
  accesRows: AccesLogicielCaisseRow[] = [];
  code_station = '';
  erpStationId = 0;
  moduleEnabled = false;
  lcConnected = false;
  syncStatus: AccesSyncStatus | null = null;
  returnUrl = '/tiers/ticketCaisse/tous';

  constructor(
    private readonly router: Router,
    private readonly headerService: HeaderService,
    private readonly accesService: AccesLogicielCaisseService,
    private readonly lcAuth: LogicielCaisseAuthService,
    private readonly moduleService: LogicielCaisseModuleService
  ) {}

  ngOnInit(): void {
    const ctx = this.lcAuth.getErpContext();
    if (!ctx) {
      void this.router.navigate(['/pages/authentication/login-v2']);
      return;
    }

    this.code_station = ctx.code_station;
    this.erpStationId = ctx.erpStationId;
    this.moduleEnabled = this.moduleService.isEnabled(ctx.code_station);
    this.lcConnected = this.lcAuth.isAuthenticated();
    this.returnUrl =
      this.router.parseUrl(this.router.url).queryParams['returnUrl'] ||
      '/tiers/ticketCaisse/tous';

    this.applyHeader();
    this.loadAcces();
  }

  ngAfterViewInit(): void {
    setTimeout(() => Feather.replace(), 0);
  }

  needsConfiguration(): boolean {
    return !this.syncStatus?.sync_ok;
  }

  private applyHeader(): void {
    const buttons: {
      label: string;
      type: 'primary' | 'secondary';
      action?: () => void;
    }[] = [];

    if (this.accesRows.length > 0 && this.lcConnected && this.syncStatus?.sync_ok) {
      buttons.push({
        label: 'Ouvrir les tickets',
        type: 'primary',
        action: () => navigateLogicielCaisseReturnUrl(this.router, this.returnUrl),
      });
    } else if (!this.loading && this.syncStatus?.sync_ok && !this.lcConnected) {
      buttons.push({
        label: 'Continuer la configuration',
        type: 'primary',
        action: () => this.goToConfigure(),
      });
    } else if (!this.loading && this.needsConfiguration()) {
      buttons.push({
        label: 'Configurer le logiciel caisse',
        type: 'primary',
        action: () => this.startConfiguration(),
      });
    }

    this.headerService.setConfig({
      title: 'Accès logiciel caisse',
      buttons,
    });
  }

  loadAcces(): void {
    this.loading = true;
    this.accesService.getSyncStatus(this.code_station, this.erpStationId).subscribe({
      next: (status) => {
        this.syncStatus = status;
        this.accesRows = status.erp?.acces ?? [];
        this.loading = false;
        this.applyHeader();
        setTimeout(() => Feather.replace(), 0);
      },
      error: () => {
        this.loading = false;
        this.accesRows = [];
        this.syncStatus = null;
        this.applyHeader();
        setTimeout(() => Feather.replace(), 0);
      },
    });
  }

  startConfiguration(): void {
    const action = this.syncStatus?.action;
    if (action === 'configure' || action === 'resync') {
      void this.router.navigate(['/tiers/acces-logiciel-caisse/add'], {
        queryParams: { returnUrl: this.returnUrl },
      });
      return;
    }
    void this.router.navigate(['/tiers/acces-logiciel-caisse/onboarding'], {
      queryParams: { returnUrl: this.returnUrl },
    });
  }

  goToConfigure(): void {
    void this.router.navigate(['/tiers/acces-logiciel-caisse/add'], {
      queryParams: { returnUrl: this.returnUrl },
    });
  }

  openTickets(): void {
    navigateLogicielCaisseReturnUrl(this.router, this.returnUrl);
  }
}
